import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag, MapPin } from 'lucide-react';
const recentSales = [{
  name: 'María L.',
  city: 'Buenos Aires'
}, {
  name: 'Carolina S.',
  city: 'Córdoba'
}, {
  name: 'Luciana M.',
  city: 'Rosario'
}, {
  name: 'Valentina R.',
  city: 'Mendoza'
}, {
  name: 'Florencia G.',
  city: 'La Plata'
}, {
  name: 'Agustina P.',
  city: 'Tucumán'
}, {
  name: 'Romina D.',
  city: 'Mar del Plata'
}, {
  name: 'Daniela F.',
  city: 'Santa Fe'
}, {
  name: 'Paula B.',
  city: 'Salta'
}, {
  name: 'Camila T.',
  city: 'Neuquén'
}, {
  name: 'Sofía H.',
  city: 'San Juan'
}, {
  name: 'Julieta V.',
  city: 'Bahía Blanca'
}];
function getTimeAgo(): string {
  const minutes = Math.floor(Math.random() * 15) + 2;
  return `hace ${minutes} min`;
}
export function SalesToast() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeAgo, setTimeAgo] = useState(getTimeAgo());
  useEffect(() => {
    // First notification after 8 seconds
    const initialTimeout = setTimeout(() => {
      setTimeAgo(getTimeAgo());
      setVisible(true);
    }, 8000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 4.5 seconds
    const hideTimeout = setTimeout(() => {
      setVisible(false);
    }, 4500);
    return () => clearTimeout(hideTimeout);
  }, [visible, currentIndex]);
  useEffect(() => {
    if (visible) return;
    // Show next notification 25 seconds after hiding
    const showTimeout = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % recentSales.length);
      setTimeAgo(getTimeAgo());
      setVisible(true);
    }, 25000);
    return () => clearTimeout(showTimeout);
  }, [visible]);
  const sale = recentSales[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50" aria-live="polite" data-id="element-97">
      <AnimatePresence data-id="element-98">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 20,
        x: -10
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 10,
        x: -10
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white rounded-xl shadow-lg border border-stone-100 p-3.5 pr-5 flex items-center gap-3 max-w-xs" data-id="element-99">
            <div className="w-10 h-10 rounded-full bg-sage-light flex items-center justify-center flex-shrink-0" data-id="element-100">
              <ShoppingBag className="w-5 h-5 text-sage" data-id="element-101" />
            </div>
            <div className="min-w-0" data-id="element-102">
              <p className="text-sm font-medium text-brown-heading leading-tight" data-id="element-103">
                {sale.name} compró{' '}
                <span className="text-sage-dark" data-id="element-104">Semana Resuelta</span>
              </p>
              <div className="flex items-center gap-1.5 mt-0.5" data-id="element-105">
                <MapPin className="w-3 h-3 text-brown-body/40" data-id="element-106" />
                <span className="text-xs text-brown-body/50" data-id="element-107">
                  {sale.city} · {timeAgo}
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}